<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col-sm-2">

        </div>
        <div class="col">
            <h1>{{getTotalPayouts}}</h1>
        </div>

      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Date Paid</th>
          <th>Amount</th>
          <th>Payment Status</th>
          <th>Payment Method</th>
        </template>

        <template slot-scope="{row}">


          <td scope="owner-details">
            {{row.payoutDate.split("T")[0]}}
          </td>


          <td scope="amount">
            GHC {{row.amount}}
          </td>


          <td class="payment-status">
            {{row.paymentStatus}}
          </td>


          <td class="payment-methods">
            {{row.paymentMethod}}<br>
          </td>
        </template>

      </base-table>
    </div>


  </div>
</template>
<script>
import {mapState} from 'vuex';

  export default {
    name: 'projects-table',
    props: {
      type: {
        type: String
      },
      title: String,
    },
   created() {
      if (this.$store.state.owner.owner.payouts && this.$store.state.owner.owner.payouts.length > 0) {
        console.log("true");
      } else {
        this.$store.dispatch('owner/fetchOwnerByIdExternal')
      }
    },

    computed: {
      ...mapState(['owner']),
      tableData () {
          return this.owner.owner.payouts
      },
      getTotalPayouts(){
        let count = 0
        this.tableData.forEach((item) => {
          count += parseInt(item.amount)
        });
        return `Total: GHC ${count.toString().split( /(?=(?:...)*$)/ )}`
      },
    },
  }
</script>
<style>
</style>
